export { type VacancyListProps, default as VacancyList } from './VacancyList';
